<template>
  <v-dialog v-model="value" persistent max-width="600px" scrollable>
    <v-card v-show="!loading && isError" class="box box_error">
      <div class="close">
        <v-btn flat icon @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <p class="error--text error_title">
        <span>
          <v-icon size="32" color="error">error</v-icon>
        </span>
        Ocurrió un error
      </p>
      <p class="error_text">{{ message }}</p>
    </v-card>
    <v-card v-show="!loading && isError === false" class="box box_error">
      <div v-show="showCloseOnSuccess" class="close">
        <v-btn flat icon @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <span class="circle">
        <v-icon size="32" color="success">check</v-icon>
      </span>
      <p class="error_title mt-3">
        {{ message }}
      </p>
    </v-card>
    <v-card v-show="loading === true" class="box">
      <v-progress-circular
        indeterminate
        color="primary"
        size="65"
      ></v-progress-circular>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    isError: Boolean,
    loading: Boolean,
    message: String,
    autoClose: {
      type: Boolean,
      default: false,
    },
    showCloseOnSuccess: {
      type: Boolean,
      default: false,
    },
    closeAfter_ms: {
      type: Number,
      default: 1500,
    },
  },
  methods: {
    close() {
      this.$emit('input', !this.value)
    },
  },
  watch: {
    loading: function () {
      if (this.loading === false) {
        if (this.autoClose === true && this.value === true) {
          const time = setTimeout(() => {
            this.close()
            clearTimeout(time)
          }, this.closeAfter_ms)
        }
      }
    },
  },
}
</script>

<style scoped>
.close {
  position: absolute;
  top: 10px;
  right: 10px;
}
.box {
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box.box_error {
  height: 300px;
}
.error_title {
  font-size: 25px;
}
.error_text {
  font-size: 20px;
}
.circle {
  display: inline-block;
  padding: 6px 8px;
  border-radius: 100% !important;
  background-color: #d1fae5;
}
</style>
